import { render, staticRenderFns } from "./AdminStatsAirframes.vue?vue&type=template&id=778de529&"
import script from "./AdminStatsAirframes.vue?vue&type=script&lang=js&"
export * from "./AdminStatsAirframes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports